const loginInitialValues = {
  name: "",
  password: "",
};

export default loginInitialValues;
